import { Colors } from '@banhala/ui-kit';
import type { MyPersonalizationTabItem } from '../pages/MyPersonalization/types';

export type MyPersonalizationTabRoute = MyPersonalizationTabItem;

export const myPersonalizationTabRoutes: MyPersonalizationTabItem[] = [
  {
    id: 'body_shape_and_beauty',
    key: 'body_shape_and_beauty',
    type: 'CUSTOM',
    name: '체형/뷰티 ',
    screen_name: 'BODY_SHAPE_AND_BEAUTY',
    render: {
      selected_color: Colors.content_primary,
      unselected_color: Colors.content_secondary,
    },
  },
  {
    id: 'size',
    key: 'size',
    type: 'CUSTOM',
    name: '사이즈',
    screen_name: 'SIZE',
    render: {
      selected_color: Colors.content_primary,
      unselected_color: Colors.content_secondary,
    },
  },
];
